var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.48996 27.2194C4.94902 27.0321 7.87441 25.6707 10.5774 20.451",
    stroke: "#2B2B2C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5865 10.5482C16.5865 10.5482 20.9268 5.8306 22.4364 4.69847C23.946 3.56633 25.6443 3.75495 25.6443 3.75495",
    stroke: "#2B2B2C",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1792 9.86287L7.43148 16.653C6.65633 17.4331 6.65633 18.6926 7.43148 19.4726L11.9468 24.0164C12.7289 24.8033 14.0021 24.8033 14.7841 24.0164L18.2056 20.5733C18.578 20.1986 18.787 19.6918 18.787 19.1636V12.4692C18.787 11.941 18.578 11.4342 18.2056 11.0595L17.0165 9.86286C16.2345 9.0759 14.9613 9.0759 14.1792 9.86287Z",
    fill: "#2B2B2C",
    stroke: "#2B2B2C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1174 21.9006L10.9913 19.7745L15.9524 14.8135V19.0656L13.1174 21.9006Z",
    fill: "#B9C9DE",
    stroke: "#B9C9DE",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2534 12.1141L25.8739 8.4353L24.4943 12.1141C24.1331 13.0774 24.8452 14.1048 25.8739 14.1048C26.9026 14.1048 27.6146 13.0774 27.2534 12.1141Z",
    fill: "#2B2B2C",
    stroke: "#2B2B2C",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTank);
export default __webpack_public_path__ + "static/media/Tank.0b6ea008686a9acaf29878696c6a8332.svg";
export { ForwardRef as ReactComponent };